document.addEventListener('DOMContentLoaded', () => {
	document.addEventListener('facetwp-loaded', () => {
		const searchField = document.querySelector('#search-field');

		if (searchField) {
			const searchTerm = searchField.querySelector('input').value;
			const elementsToToggle = document.querySelectorAll('.search-container .toggle, .search-results, .loadmore, .total-results');

			if (searchTerm) {
				elementsToToggle.forEach((element) => element.classList.remove('hidden'));
			} else {
				elementsToToggle.forEach((element) => element.classList.add('hidden'));
			}
		}
	});
});
